<div class="dialog-title-content">
  <h1 mat-dialog-title>
    {{ 'commonLabels.stackingPlanReviewDetails' | xTranslate }}
  </h1>
  <button mat-icon-button mat-dialog-close color="primary">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <form [formGroup]="reviewedForm" *ngIf="reviewedForm">
    <div class="form-ctrl">
      <label class="miq-form-input-label miq-form-input-label--required">{{
        'commonLabels.reviewedOnLabel' | xTranslate
      }}</label>
      <mat-form-field appearance="outline" (click)="lastReviewedDate.open()">
        <input
          readonly
          matInput
          autocomplete="no-autofill"
          formControlName="reviewedOn"
          [matDatepicker]="lastReviewedDate"
        />
        <mat-datepicker-toggle matSuffix [for]="lastReviewedDate"></mat-datepicker-toggle>
        <mat-datepicker #lastReviewedDate></mat-datepicker>
      </mat-form-field>
      <span class="field-error" *ngIf="reviewedForm.controls.reviewedOn?.errors?.noFutureDate">
        {{ 'errorMessages.noFutureDate' | xTranslate }}
      </span>
    </div>
    <div class="form-ctrl">
      <label class="miq-form-input-label miq-form-input-label--required">{{
        'commonLabels.reviewedByLabel' | xTranslate
      }}</label>
      <mat-form-field hideRequiredMarker appearance="outline">
        <input
          matInput
          type="search"
          autocomplete="off"
          formControlName="reviewedBy"
          [matAutocomplete]="auto"
          [placeholder]="'commonLabels.typeToSearch' | xTranslate"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayUser">
          <ng-container>
            <ng-container *ngFor="let cbreEmployee of cbreEmployees$ | async">
              <mat-option [disabled]="!cbreEmployee.id" [value]="cbreEmployee" class="sp-lr__employee">
                <p *ngIf="cbreEmployee.id; else notFound" class="sp-lr__employee-name">
                  {{ cbreEmployee.firstName + ' ' + cbreEmployee.lastName }}
                  <span class="sp-lr__employee-email">{{ cbreEmployee.emailAddress }}</span>
                </p>
                <ng-template #notFound>{{ 'commonLabels.noResults' | xTranslate }}</ng-template>
              </mat-option>
            </ng-container>
          </ng-container>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" [disabled]="reviewedForm?.invalid || reviewerChange" (click)="saveReviewer()">
    {{ 'commonLabels.save' | xTranslate }}
  </button>
</div>
